module.exports = __webpack_public_path__ + "static/media/feller_youtube.7174d00d.png";